<template>
    <div>
        <v-alert :value="true" class="hide-on-print" type="success">
            Your amount has been paid and application has been received!
        </v-alert>
        <div v-html="printContent.show_content" class="hide-on-print"></div>
        <div v-html="printContent.print_content" id="printContent">
        </div>
        <div style="width: 100%;" class="hide-on-print">
            <div style="float: right;">
                <v-btn color="primary" large dressed @click="print" class="hide-on-xs mr-2">Print</v-btn>
                <v-btn color="secondary" large dressed @click="pdfDownload"
                       class="mr-2">Download as pdf
                </v-btn>
                <v-btn color="secondary" large dressed
                       @click="moveToApplyAgain"
                       style="float: right"
                       class="mr-2">Apply again
                </v-btn>
            </div>

        </div>
    </div>
</template>

<script>
    import {API_URL, VERSION} from "../../config/config";
    import Http from 'axios';

    export default {
        name: "Success",
        data() {
            return {
                printContent: {}
            }
        },
        beforeRouteEnter(to, from, next) {
            if (from.name && (from.name === 'OnArrival' || from.name === 'OnlineApplication' || from.name === 'OnArrival')) {
                next(vm => {

                    vm.$router.push({
                        name: 'OnlineApplication'
                    })
                })
            }
            next();
        },
        methods: {
            moveToApplyAgain() {
                let apply_type = this.printContent.type;
                let office = this.printContent.office;
                if (apply_type === 'arrival') {
                    this.$router.push({
                        name: 'OnArrival',
                        params: {office}
                    })
                } else {
                    this.$router.push({
                        name: 'OnlineApplication'
                    })
                }
            },
            pdfDownload() {
                const submission_no = this.$route.params.submission_no;
                const token = this.$route.query.token;
                let pos = window.localStorage.getItem('pos');
                if (!pos)
                    pos = 0;

                window.open(`${API_URL}${VERSION}/generate-print-form/${submission_no}?token=${token}&pos=${pos}&pdf`, '_blank')
            },
            print(){
                window.print()
            }
        },
        mounted() {
            const submission_no = this.$route.params.submission_no;
            const token = this.$route.query.token;
            let pos = window.localStorage.getItem('pos');
            if (!pos)
                pos = 0;

            Http.get(`${API_URL}${VERSION}/generate-print-form/${submission_no}?token=${token}&pos=${pos}`).then((res) => {
                this.printContent = res.data;
            })
        }
    }
</script>


<style>
    #printContent {
        display: none;
    }

    @media print {
        .hide-on-print {
            display: none;
        }


        #printContent {
            display: block;
        }
    }
</style>


